/**
 * @generated SignedSource<<751e753b9292e5c1f795eed20c4a6fbe>>
 * @relayHash 0772c5cf0619aa6804bbac3aeb521bcb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1243411b8b1ede5b2d6ccf7cdde80e5586dba6ff71e9f9ef515d28ff0fc38b8e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
};
export type ProjectPanelQuery$data = {
  readonly townsquare: {
    readonly project: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectPanelHeader" | "ProjectStatus" | "ProjectTags">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ProjectPanelHeader"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectTags"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectStatus"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "TownsquareIconURIs",
                "kind": "LinkedField",
                "name": "iconUrl",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareThemeURIs",
                    "kind": "LinkedField",
                    "name": "roundedSquare",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "dark"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "light"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareTag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareProjectState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "label"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1243411b8b1ede5b2d6ccf7cdde80e5586dba6ff71e9f9ef515d28ff0fc38b8e",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9fb3d733b613c60094254ef46ea77897";

export default node;
